// Identidade visual da loja: a foto (logo) e a capa (faixa) que aparecem no topo
// do cardapio, mais a cor da marca.
//
// Os tres campos JA EXISTEM no backend e ja chegam na loja pelo
// `aps://integracao/cardapio/empresa/{id}`:
//   foto -> empresa.imagem
//   capa -> empresa.empresaConfiguracao.parametros.visual.cardapio.faixa
//   cor  -> empresa.empresaConfiguracao.parametros.visual.cor
//
// O que ainda NAO existe e o caminho de ESCRITA para a loja. O upload
// (`arquivo/envia`) so responde no `sirius` autenticado; no `sirius-s` e 404.
// Por isso a gravacao e local por enquanto - ver `visualSalva` no EcommerceService.
export class VisualIdentidade {
  foto: string;
  capa: string;
  cor: string;

  // Serve para decidir se vale sobrescrever o que veio do backend: um override
  // todo vazio nao pode apagar a identidade real da empresa.
  preenchida(): boolean {
    return !!(this.foto || this.capa || this.cor);
  }
}

// Tamanho recomendado ao lojista para a capa. A vitrine desenha a faixa em 4:1
// (`.loja-cobertura` no tema da loja) e, no desktop, com ate ~1250px de largura.
export const CAPA_RECOMENDADA = {
  largura: 1600,
  altura: 400,
  larguraMinima: 1200,
  // Fora desta faixa de proporcao o corte pelo centro ja come parte da arte.
  proporcaoMinima: 3.5,
  proporcaoMaxima: 4.5,
  tamanhoMaximoMb: 1,
};

// Avisos sobre uma capa a partir das dimensoes da imagem. Lista vazia = serve.
// Nao bloqueia: o lojista pode querer usar a imagem mesmo assim.
export function capaAvisos(largura: number, altura: number): string[] {
  if (!largura || !altura) {
    return [];
  }
  const avisos: string[] = [];
  const proporcao = largura / altura;
  if (proporcao < CAPA_RECOMENDADA.proporcaoMinima) {
    avisos.push(`A imagem e alta demais para a faixa (${largura} x ${altura}). O topo e o pe serao cortados.`);
  } else if (proporcao > CAPA_RECOMENDADA.proporcaoMaxima) {
    avisos.push(`A imagem e baixa demais para a faixa (${largura} x ${altura}). As laterais serao cortadas.`);
  }
  if (largura < CAPA_RECOMENDADA.larguraMinima) {
    avisos.push(`Com ${largura} pixels de largura a capa pode sair borrada no computador.`);
  }
  return avisos;
}
